import React, {useMemo} from 'react'
import styled from 'styled-components'
import {getBorder, getCurrencyValue} from 'utils'
import {CheckboxItem, PackageIcon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopCartPackageContentItemProps} from './GiftShopCartPackageContentItemProps'

const StyledContainer = styled.div`
  ${({theme}) => ({
    borderBottom: getBorder(1, 'solid', theme.white_4),
  })}
  display: flex;
  align-items: center;
  margin: 0 ${convertUnit(20)};
  padding: ${convertUnit(16)} 0;
  gap: ${convertUnit(20)};
`

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: anywhere;
`

const StyledCartItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${convertUnit(20)};
`

const StyledDescriptionCreator = styled(Paragraph)`
  margin-top: ${convertUnit(2)};
`

const StyledDescriptionPrice = styled(Paragraph)`
  margin-top: ${convertUnit(2)};
`

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledCheckboxItem = styled(CheckboxItem)`
  ${({theme}) => ({borderColor: theme.gray_5})}
`

export default function GiftShopCartPackageContentItem({
  data,
  isSelected,
  onSelect,
  onClickItem,
}: GiftShopCartPackageContentItemProps) {
  const {price, creator_name, tree_name} = data

  const handleRenderPrice = useMemo(
    () => (
      <StyledPriceContainer>
        <StyledDescriptionPrice
          fontSize="m"
          fontWeight="bold"
          color="primary_5">
          {getCurrencyValue(price)}
        </StyledDescriptionPrice>
      </StyledPriceContainer>
    ),
    [price],
  )

  return (
    <StyledContainer>
      <StyledCheckboxItem
        isSelected={isSelected}
        onClick={() => onSelect(!isSelected)}
      />
      <StyledCartItemContainer onClick={() => onClickItem && onClickItem(data)}>
        <PackageIcon size={80} />
        <StyledDescriptionContainer>
          <Paragraph fontSize="m" fontWeight="bold">
            {tree_name}
          </Paragraph>
          <StyledDescriptionCreator fontWeight="medium" color="gray_5">
            {creator_name}
          </StyledDescriptionCreator>
          {handleRenderPrice}
        </StyledDescriptionContainer>
      </StyledCartItemContainer>
    </StyledContainer>
  )
}
